
export enum FaqItemKey {
  SYNCHRONIZING_YOUR_ACCOUNT = 'synchronizing-your-account',
  BRIEFING = 'campaign-briefing',
  SOURCING_CONTACTS = 'sourcing-contacts',
  QUALIFYING_CONTACTS = 'qualifying-contacts',
  BLACKLISTING_CONTACTS = 'blacklisting-contacts',
  CREATING_CAMPAIGN_FLOW = 'creating-campaign-flow',
  CAMPAIGN_SETTINGS = 'campaign-settings',
  CAMPAIGN_OVERVIEW_PERFORMANCE = 'campaign-overview-performance'
}
